export const PLACEHOLDER_API = {
  GET_PLACEHOLDERS: 'classes/{classId}/placeholder?calculateTime={calculateTime}',
  ADD_PLACEHOLDER: 'classes/{classId}/placeholder',
  UPDATE_PLACEHOLDER: 'classes/{classId}/placeholder/{placeholderId}',
  DELETE_PLACEHOLDER: 'classes/{classId}/placeholder/{placeholderId}',
  RELATE_PLACEHOLDERS: 'classes/{classId}/scheduleEntry/placeholders',
  UNRELATE_PLACEHOLDERS: 'classes/{classId}/scheduleEntry/placeholders',
  GET_SCHEDULE_PLACEHOLDER: 'classes/{classId}/placeholder/scheduleDetail',
  ASSIGN_MAIN_PLACEHOLDER_TO_SCHEDULE: 'classes/{classId}/scheduleEntry/{scheduleEntryId}/{placeholderId}/dates',
  ASSIGN_PLACEHOLDERS_TO_SCHEDULE: 'classes/{classId}/scheduleEntry/{scheduleEntryId}/dates',
}

export const PLACEHOLDER_PARAMS = {
  CLASS_ID: '{classId}',
  CALCULATE_TIME: '{calculateTime}',
  PLACEHOLDER_ID: '{placeholderId}',
  SCHEDULE_ENTRY_ID: '{scheduleEntryId}'
}